(function ($) {
  $(document).ready(function () {
    // Broken links
    $('img').on('error', function () {
      $(this).addClass('img-error');
    });

    // Place document manipulation code here
    $('#menu-toggle').on('click', function () {
      $('nav.nav').toggleClass('open');
      $(this).toggleClass('open');
    });

    /* Navigation
    -------------------------------------------------*/
    $('.h-w1 > .section-inner').hover(
      function () {
        $('#header .h-w1').addClass('hover');
      },
      function () {
        $('#header .h-w1').removeClass('hover');
      }
    );

    /*Navigation - Submenu
    -----------------------------------------------------*/

    var clickedSubmenu = false;
    $('.menu-item-has-children .sub-menu').on('click', function () {
      clickedSubmenu = true;
    });

    $('.menu-item-has-children').on('click', function () {
      // Don't expand/contract if clicking a link inside the submenu.
      if (!clickedSubmenu) {
        $('.menu-item-has-children > .sub-menu:first-child ').toggleClass('open');
        $(this).toggleClass('open');
      }
      clickedSubmenu = false;
    });

    $('.menu-item-has-children').addClass('closed');
    $(this).toggleClass('closed');

    var current = location.pathname;
    $('#subnav li a').each(function () {
      var $this = $(this);
      if ($this.attr('href').indexOf(current) !== -1) {
        $this.addClass('current-menu-item');
      }
    });

    /*
    Mobile menu
    -----------------------------------------------------*/

    $('#menu-toggle').on('click', function () {
      $('body').toggleClass('body-overflow');
    });

    /*
    Carousel
    -----------------------------------------------------*/
    $('.carousel').on('afterChange',function(e,o){
      //on change slide = do action
      $('iframe').each(function(){
          $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');    
      });
    }).slick({});

    /* Headroom
    ------------------------------------------------------*/
    $('#header .h-w1').headroom();

    /*
    Smooth Scrolling
    ----------------------------------------------------*/
    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') ==
            this.pathname.replace(/^\//, '') &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate(
              {
                scrollTop: target.offset().top,
              },
              1000,
              function () {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();
                if ($target.is(':focus')) {
                  // Checking if the target was focused
                  return false;
                } else {
                  $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                  $target.focus(); // Set focus again
                }
              }
            );
          }
        }
      });

    /*
    Tabs
    -----------------------------------------------------*/
    $('[role="tablist"] li:first-child').attr({
      'aria-selected': 'true',
    });

    $('.tab-content .tab-box:first-child').attr({
      'aria-hidden': 'false',
    });

    $("li[role='tab']").on('click, focus', function () {
      $(this).siblings().attr('aria-selected', 'false'); //deselect all the tabs
      $(this).attr('aria-selected', 'true'); // select this tab
      var tabpanid = $(this).attr('aria-controls'); //find out what tab panel this tab controls
      var tabpan = $('#' + tabpanid);
      $(this)
        .parent('ul')
        .next('.tab-content')
        .children("div[role='tabpanel']")
        .attr('aria-hidden', 'true'); //hide all the panels
      tabpan.attr('aria-hidden', 'false'); // show our panel
    });

    //mobile
    function initTab() {
      $('.tabs .inner, .col-accord .inner').attr({
        'aria-hidden': 'true',
      });
    }
    if ($(window).width() < 641) {
      initTab();
    }
    $(window).resize(function () {
      initTab();
    });

    $('.tab-title').on('click', function () {
      var theBox = $(this).parent('.tab-box');
      $(theBox)
        .siblings('.tab-box')
        .not(theBox)
        .children('.tab-title.open')
        .removeClass('open');

      $(this).toggleClass('open');

      if ($(this).next('.inner').attr('aria-hidden') == 'true') {
        $(this)
          .parent('.tab-box')
          .siblings()
          .children('.inner')
          .attr('aria-hidden', 'true');
        $(this).next('.inner').attr('aria-hidden', 'false');
      } else {
        $(this).next('.inner').attr('aria-hidden', 'true');
      }
    });

    /*-----------------------------------------------------*/

    /*
    Accordion
    -----------------------------------------------------*/
    $('.accordion-title').on('click', function () {
      var theBox = $(this).parent('.accordion-item');
      $(theBox)
        .siblings('.accordion-item')
        .not(theBox)
        .children('.accordion-title.open')
        .removeClass('open');

      $(this).toggleClass('open');

      if ($(this).next('.inner').attr('aria-hidden') == 'true') {
        $(this)
          .parent('.accordion-item')
          .siblings()
          .children('.inner')
          .attr('aria-hidden', 'true');
        $(this).next('.inner').attr('aria-hidden', 'false');
      } else {
        $(this).next('.inner').attr('aria-hidden', 'true');
      }
    });

    /*
    Search bar
    -----------------------------------------------------*/

    $('.icon-search').on('click', function () {
      $('.search-banner').toggleClass('open close');
    });

    /*-----------------------------------------------------*/


    /*
    Single Find Advisor Testimonials
    -----------------------------------------------------*/
    $('.single-advisor--carousel').slick({
      'slide' : '.single-advisor--carousel--slide',
      'rows' : 0,
      'infinite' : true,
      'speed' : 200,
      'dots' : true,
      'arrows' : true,
      'autoplay' : false,
      'fade' : true,
      'adaptiveHeight' : true,
      'draggable' : false,
      'appendArrows' : '.single-advisor--carousel--controls',
      'appendDots' : '.single-advisor--carousel--dots',
      'prevArrow' : '<div class="single-advisor--carousel--prev"><svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 5C11 5.18941 10.9276 5.37106 10.7987 5.50499C10.6697 5.63892 10.4949 5.71416 10.3126 5.71416L2.34809 5.71416L5.29989 8.77932C5.3638 8.84572 5.4145 8.92454 5.44909 9.0113C5.48368 9.09805 5.50148 9.19104 5.50148 9.28494C5.50148 9.37884 5.48368 9.47183 5.44909 9.55858C5.4145 9.64534 5.3638 9.72416 5.29989 9.79056C5.23597 9.85696 5.1601 9.90963 5.07659 9.94557C4.99308 9.9815 4.90358 10 4.81319 10C4.7228 10 4.6333 9.9815 4.54979 9.94557C4.46629 9.90963 4.39041 9.85696 4.32649 9.79056L0.201956 5.50562C0.137938 5.43928 0.0871484 5.36048 0.0524929 5.27371C0.0178383 5.18695 -2.22663e-07 5.09394 -2.18557e-07 5C-2.14451e-07 4.90606 0.0178383 4.81305 0.0524929 4.72629C0.0871485 4.63952 0.137938 4.56072 0.201956 4.49438L4.3265 0.209436C4.39041 0.143036 4.46629 0.0903655 4.54979 0.0544304C4.6333 0.0184953 4.7228 -2.74385e-07 4.81319 -2.70434e-07C4.90358 -2.66483e-07 4.99308 0.0184953 5.07659 0.0544304C5.1601 0.0903655 5.23597 0.143036 5.29989 0.209436C5.42897 0.343535 5.50148 0.525414 5.50148 0.715059C5.50148 0.808962 5.48368 0.901946 5.44909 0.988701C5.4145 1.07546 5.3638 1.15428 5.29989 1.22068L2.34809 4.28584L10.3126 4.28584C10.4949 4.28584 10.6697 4.36108 10.7987 4.49502C10.9276 4.62895 11 4.81059 11 5Z" fill="#234075"/></svg></div>',
      'nextArrow' : '<div class="single-advisor--carousel--next"><svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M-2.18557e-07 5C-2.26836e-07 4.81059 0.0724246 4.62894 0.201341 4.49501C0.330258 4.36108 0.505107 4.28584 0.687423 4.28584L8.65191 4.28584L5.70011 1.22068C5.6362 1.15428 5.5855 1.07546 5.55091 0.988701C5.51632 0.901946 5.49852 0.808962 5.49852 0.715059C5.49852 0.621156 5.51632 0.528172 5.55091 0.441417C5.5855 0.354663 5.6362 0.275835 5.70011 0.209436C5.76403 0.143037 5.8399 0.0903652 5.92341 0.0544307C6.00692 0.0184953 6.09642 6.87191e-07 6.18681 6.8324e-07C6.2772 6.79289e-07 6.3667 0.0184953 6.45021 0.0544307C6.53371 0.0903651 6.60959 0.143037 6.6735 0.209436L10.798 4.49438C10.8621 4.56072 10.9129 4.63952 10.9475 4.72629C10.9822 4.81305 11 4.90606 11 5C11 5.09394 10.9822 5.18695 10.9475 5.27371C10.9129 5.36048 10.8621 5.43928 10.798 5.50562L6.6735 9.79056C6.60959 9.85696 6.53371 9.90963 6.45021 9.94557C6.3667 9.9815 6.2772 10 6.18681 10C6.09642 10 6.00692 9.9815 5.92341 9.94557C5.8399 9.90963 5.76403 9.85696 5.70011 9.79056C5.57103 9.65646 5.49852 9.47459 5.49852 9.28494C5.49852 9.19104 5.51632 9.09805 5.55091 9.0113C5.5855 8.92454 5.6362 8.84572 5.70011 8.77932L8.65191 5.71416L0.687423 5.71416C0.505107 5.71416 0.330258 5.63892 0.201342 5.50498C0.0724247 5.37105 -2.10278e-07 5.18941 -2.18557e-07 5Z" fill="#234075"/></svg></div>',
    });

    /*-----------------------------------------------------*/

    /*
    Nav buttton in mobile menu
    -----------------------------------------------------*/

    //$("#menu-toggle").on('click', function() {

    //if ($("#menu-toggle").hasClass("open")) {
    // $("#menu-item-63").insertBefore("#menu-item-247");
    //}

    //});

    // $("#menu-toggle").on('click', function() {

    // 	if (!$("#menu-toggle").hasClass("open")) {
    //               $('#menu-item-63').insertAfter( $('.mobile-nav' ) );
    //           }else{
    //           }
    //       });

    /*-----------------------------------------------------*/

    /*******************************
    Object Fit
    *********************************/
    objectFitImages();

    /**********************************
    Advisor Form
    **********************************/
    /*$('#gform_2 #input_2_10 input[type="checkbox"]').on('change', function(){
      if($(this).attr('id') == 'choice_2_10_1' || $(this).attr('id') == 'choice_2_10_2' || $(this).attr('id') == 'choice_2_10_3'){
        $('#gform_2 #choice_2_10_4, #gform_2 #choice_2_10_5').prop('checked', false).trigger('click');
      }
      else if($(this).attr('id') == 'choice_2_10_4'){
        $(this).parent().siblings().children('input[type="checkbox"]').prop('checked', false).trigger('click');
      }
      else{
        $(this).parent().siblings().children('input[type="checkbox"]').prop('checked', false).trigger('click');
      }
    });*/

    $(
      '#gform_2 #choice_2_10_1, #gform_2 #choice_2_10_2, #gform_2 #choice_2_10_3'
    ).on('change', function () {
      if ($(this).is(':checked')) {
        if ($('#choice_2_10_4').is(':checked')) {
          $('#choice_2_10_4').trigger('click');
        }
        if ($('#choice_2_10_5').is(':checked')) {
          $('#choice_2_10_5').trigger('click');
        }
      }
    });

    $('#gform_2 #choice_2_10_4').on('change', function () {
      if ($(this).is(':checked')) {
        if ($('#choice_2_10_1').is(':checked')) {
          $('#choice_2_10_1').trigger('click');
        }
        if ($('#choice_2_10_2').is(':checked')) {
          $('#choice_2_10_2').trigger('click');
        }
        if ($('#choice_2_10_3').is(':checked')) {
          $('#choice_2_10_3').trigger('click');
        }
        if ($('#choice_2_10_5').is(':checked')) {
          $('#choice_2_10_5').trigger('click');
        }
      }
    });

    $('#gform_2 #choice_2_10_5').on('change', function () {
      if ($(this).is(':checked')) {
        if ($('#choice_2_10_1').is(':checked')) {
          $('#choice_2_10_1').trigger('click');
        }
        if ($('#choice_2_10_2').is(':checked')) {
          $('#choice_2_10_2').trigger('click');
        }
        if ($('#choice_2_10_3').is(':checked')) {
          $('#choice_2_10_3').trigger('click');
        }
        if ($('#choice_2_10_4').is(':checked')) {
          $('#choice_2_10_4').trigger('click');
        }
      }
    });

    /*******************************
    Responsive JS
    **********************************/
    enquire.register('screen and (max-width:960px)', {
      // OPTIONAL
      // If supplied, triggered when a media query matches.
      match: function () {
        //if ($("#menu-toggle").hasClass("open")) {
        //$('#menu-item-63').insertAfter( $('#menu-item-18' ) );

        //}else{

        //$('#menu-item-63').insertAfter( $('.mobile-nav' ) );
        //}

        $('#secondary').insertAfter($('.f-w1'));
      },
      // OPTIONAL, defaults to false
      // If set to true, defers execution of the setup function
      // until the first time the media query is matched
      deferSetup: true,
    });

    enquire.register('screen and (min-width:960px)', {
      // OPTIONAL
      // If supplied, triggered when a media query matches.
      match: function () {
        //$('#menu-item-63').insertAfter( $('#menu-item-18' ) );
        $('#secondary').insertAfter($('#primary'));
      },
      // OPTIONAL, defaults to false
      // If set to true, defers execution of the setup function
      // until the first time the media query is matched
      deferSetup: true,
    });

    /*******************************
    Advisor - ZIP CODE DISPLAY
    **********************************/

    var value = $('.sf-input-text').val();
    $('.directory h3 span').text(value);

    /*******************************
    Resource VIEW list/grid style
    **********************************/

    $('.icon-list-bullet').on('click', function () {
      $('.resources-results-wrapper').addClass('row-style');
      $('.icon-list-bullet').removeClass('icon-grey');
      $('.icon-grid').addClass('icon-grey');
      return false;
    });

    $('.icon-grid').on('click', function () {
      $('.resources-results-wrapper').removeClass('row-style');
      $('.icon-grid').removeClass('icon-grey');
      $('.icon-list-bullet').addClass('icon-grey');
      return false;
    });

    //detects the start of an ajax request being made
    $(document).on('sf:ajaxstart', '.searchandfilter', function () {
      console.log('ajax start');
    });

    //detects when the ajax request has finished and the content has been updated
    // - add scripts that apply to your results here

    $(document).on('sf:ajaxfinish', '.searchandfilter', function () {
      console.log('ajax complete');
      //so load your lightbox or JS scripts here again

      /*******************************
    Resource VIEW list/grid style
    **********************************/

      $('.icon-list-bullet').on('click', function () {
        $('.resources-results-wrapper').addClass('grid-style');
        $('.icon-list-bullet').addClass('icon-grey');
        $('.icon-grid').removeClass('icon-grey');
      });

      $('.icon-grid').on('click', function () {
        $('.resources-results-wrapper').removeClass('grid-style');
        $('.icon-grid').addClass('icon-grey');
        $('.icon-list-bullet').removeClass('icon-grey');
      });

      /*******************************
    Advisor - ZIP CODE DISPLAY
    **********************************/

      var value = $('.sf-input-text').val();
      $('.directory h3 span').text(value);
    });
  });
})(jQuery);

/*******************************
Newsletter- Vanilla JS
**********************************/

let newsletter = document.getElementById("newsletter")

function openNewsletter(){
  newsletter.classList.add("newsletter--active")
}

function closeNewsletter(){
  newsletter.classList.remove("newsletter--active")
}